import React from 'react';
import toCurrency from 'utils/toCurrency';
import { getCatalogoDelMes } from 'api/catalogos';
import {
  deleteCPP, getCPPs, patchCPP, postCPP,
} from 'api/configuracion/cpp';
import { getPeriodosFiscales } from 'api/catalogos/periodosFiscales';
import PlainCRUD from 'components/PlainCRUD';

// eslint-disable-next-line react/prop-types
const CPP = ({ permission }) => (
  <PlainCRUD
    title="CPP"
    permission={permission}
    get={getCPPs}
    post={postCPP}
    patch={patchCPP}
    delete={deleteCPP}
    // readOnly
    fields={[
      {
        name: 'valor',
        label: 'Valor',
        type: 'decimal',
        render: (val) => toCurrency(val),
        decimal: true,
        required: true,
        colWidth: 200,
        colAlign: 'right',
      },
      {
        name: 'periodo',
        label: 'Periodo fiscal',
        render: (item) => (item?.periodo && item?.identificador
          ? `${item.periodo} - ${item.identificador}`
          : ''),
        type: 'select',
        required: true,
        colWidth: 200,
        useCatalog: true,
      },
      {
        name: 'mes',
        label: 'Mes',
        // render: (item) => item.descripcion,
        type: 'select',
        required: true,
        colWidth: 200,
        useCatalog: true,
      },
    ]}
    catalogs={[
      {
        permission: 'catalogodemes',
        get: getCatalogoDelMes,
        formItemName: 'mes',
      },
      {
        permission: 'periodofiscal',
        get: getPeriodosFiscales,
        formItemName: 'periodo',
        extractor: (data) => data.map((item) => ({
          ...item,
          descripcion: `${item.periodo} - ${item.identificador}`,
        })),
      },
    ]}
  />
);

export default CPP;
